module.exports = __webpack_public_path__ + "static/media/po-reman-electronic-card.fd5a7607.png";